import { render } from "./UploadInputWithButton.vue?vue&type=template&id=7960825b&ts=true"
import script from "./UploadInputWithButton.vue?vue&type=script&lang=ts"
export * from "./UploadInputWithButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../ss/AZ/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__